import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  detailsRow: {
    flexDirection: 'row',
    paddingRight: 0,
  },
  fullTextLabel: {
    // lineHeight: 16,
  },
  detailsText: {
    // lineHeight: 16,
    paddingTop: 5,
    paddingBottom: 5,
  },
  separator: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  detailsTextBorder:{
    borderWidth: 1,
    borderColor: 'red',
    color: 'red',
  }
});

export const defaultColumnWidths = [0.6, 0.4];
